import { Flex } from '../UI/Flex/Flex';
import * as style from './ChatMessage.module.less';
import * as cardStyle from './ChatMessageApproveReject.module.less';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { LogoBird } from '../Header/Logo';
import icon_check from './icons/check.svg';
import icon_feedback from './icons/feedback.svg';
import dashed_divider from './icons/dashed-divider.svg';

// Local time in the design's format, e.g. "2:22 PM".
const formatTime = (d: Date): string =>
    d.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });

interface ChatMessageApproveRejectProps {
    onApprove: (didApprove: boolean) => void;
    onFeedback: () => void;
    isLoading?: boolean;
    activeStep?: number;
    totalSteps?: number;
}

const FEEDBACK_QUESTION =
    'Review the output above. Proceed to the next step, or share feedback to refine it.';

export const ChatMessageApproveReject = observer(
    (p: ChatMessageApproveRejectProps) => {
        const clssses = classNames(style.chatmessage, 'fade-in');

        const hasSteps =
            (p.totalSteps ?? 0) > 0 && (p.activeStep ?? 0) > 0;
        const stepTitle = hasSteps
            ? `Please provide feedback (Step ${p.activeStep} of ${p.totalSteps}):`
            : 'Please provide feedback:';

        const timestamp = formatTime(new Date());

        return (
            <Flex className={clssses} direction="row">
                <div className="p-3" style={{ height: '50px' }}>
                    <LogoBird />
                </div>
                <div className="flex-grow-1 p-3 align-self-center">
                    <div className={cardStyle.card}>
                        <div className={cardStyle.stepTitle}>{stepTitle}</div>
                        <div className={cardStyle.question}>
                            {FEEDBACK_QUESTION}
                        </div>
                        <img
                            src={dashed_divider}
                            className={cardStyle.divider}
                        />
                        <div className={cardStyle.actions}>
                            <div className={cardStyle.actionsSpacer} />
                            <div className={cardStyle.buttonGroup}>
                                <button
                                    type="button"
                                    className={cardStyle.proceedButton}
                                    disabled={p.isLoading}
                                    onClick={() => {
                                        p.onApprove(true);
                                    }}
                                >
                                    {p.isLoading ? (
                                        <span className={cardStyle.spinner} />
                                    ) : (
                                        <img
                                            src={icon_check}
                                            className={cardStyle.checkIcon}
                                        />
                                    )}
                                    <span className={cardStyle.buttonLabel}>
                                        Proceed,&nbsp;No feedback
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    className={cardStyle.feedbackButton}
                                    disabled={p.isLoading}
                                    onClick={() => {
                                        p.onFeedback();
                                    }}
                                >
                                    <img
                                        src={icon_feedback}
                                        className={cardStyle.checkIcon}
                                    />
                                    <span className={cardStyle.feedbackLabel}>
                                        I have feedback
                                    </span>
                                </button>
                            </div>
                            <div className={cardStyle.timestamp}>
                                {timestamp}
                            </div>
                        </div>
                    </div>
                </div>
            </Flex>
        );
    }
);
